import { parsePhoneNumberWithError } from "libphonenumber-js"

// Map of area codes to US states
export const areaCodeToState: { [key: string]: string } = {
  "201": "NJ",
  "202": "DC",
  "203": "CT",
  "205": "AL",
  "206": "WA",
  "207": "ME",
  "208": "ID",
  "209": "CA",
  "210": "TX",
  "212": "NY",
  "213": "CA",
  "214": "TX",
  "215": "PA",
  "216": "OH",
  "217": "IL",
  "218": "MN",
  "219": "IN",
  "220": "OH",
  "223": "PA",
  "224": "IL",
  "225": "LA",
  "228": "MS",
  "229": "GA",
  "231": "MI",
  "234": "OH",
  "239": "FL",
  "240": "MD",
  "248": "MI",
  "251": "AL",
  "252": "NC",
  "253": "WA",
  "254": "TX",
  "256": "AL",
  "260": "IN",
  "262": "WI",
  "267": "PA",
  "269": "MI",
  "270": "KY",
  "272": "PA",
  "276": "VA",
  "279": "CA",
  "281": "TX",
  "301": "MD",
  "302": "DE",
  "303": "CO",
  "304": "WV",
  "305": "FL",
  "307": "WY",
  "308": "NE",
  "309": "IL",
  "310": "CA",
  "312": "IL",
  "313": "MI",
  "314": "MO",
  "315": "NY",
  "316": "KS",
  "317": "IN",
  "318": "LA",
  "319": "IA",
  "320": "MN",
  "321": "FL",
  "323": "CA",
  "325": "TX",
  "326": "OH",
  "330": "OH",
  "331": "IL",
  "332": "NY",
  "334": "AL",
  "336": "NC",
  "337": "LA",
  "339": "MA",
  "340": "VI",
  "341": "CA",
  "346": "TX",
  "347": "NY",
  "351": "MA",
  "352": "FL",
  "360": "WA",
  "361": "TX",
  "364": "KY",
  "380": "OH",
  "385": "UT",
  "386": "FL",
  "401": "RI",
  "402": "NE",
  "404": "GA",
  "405": "OK",
  "406": "MT",
  "407": "FL",
  "408": "CA",
  "409": "TX",
  "410": "MD",
  "412": "PA",
  "413": "MA",
  "414": "WI",
  "415": "CA",
  "417": "MO",
  "419": "OH",
  "423": "TN",
  "424": "CA",
  "425": "WA",
  "430": "TX",
  "432": "TX",
  "434": "VA",
  "435": "UT",
  "440": "OH",
  "442": "CA",
  "443": "MD",
  "445": "PA",
  "447": "IL",
  "448": "FL",
  "458": "OR",
  "463": "IN",
  "469": "TX",
  "470": "GA",
  "475": "CT",
  "478": "GA",
  "479": "AR",
  "480": "AZ",
  "484": "PA",
  "501": "AR",
  "502": "KY",
  "503": "OR",
  "504": "LA",
  "505": "NM",
  "507": "MN",
  "508": "MA",
  "509": "WA",
  "510": "CA",
  "512": "TX",
  "513": "OH",
  "515": "IA",
  "516": "NY",
  "517": "MI",
  "518": "NY",
  "520": "AZ",
  "530": "CA",
  "531": "NE",
  "534": "WI",
  "539": "OK",
  "540": "VA",
  "541": "OR",
  "551": "NJ",
  "559": "CA",
  "561": "FL",
  "562": "CA",
  "563": "IA",
  "564": "WA",
  "567": "OH",
  "570": "PA",
  "571": "VA",
  "573": "MO",
  "574": "IN",
  "575": "NM",
  "580": "OK",
  "585": "NY",
  "586": "MI",
  "601": "MS",
  "602": "AZ",
  "603": "NH",
  "605": "SD",
  "606": "KY",
  "607": "NY",
  "608": "WI",
  "609": "NJ",
  "610": "PA",
  "612": "MN",
  "614": "OH",
  "615": "TN",
  "616": "MI",
  "617": "MA",
  "618": "IL",
  "619": "CA",
  "620": "KS",
  "623": "AZ",
  "626": "CA",
  "628": "CA",
  "629": "TN",
  "630": "IL",
  "631": "NY",
  "636": "MO",
  "640": "NJ",
  "641": "IA",
  "646": "NY",
  "650": "CA",
  "651": "MN",
  "657": "CA",
  "659": "AL",
  "660": "MO",
  "661": "CA",
  "662": "MS",
  "667": "MD",
  "669": "CA",
  "670": "MP",
  "671": "GU",
  "678": "GA",
  "679": "MI",
  "680": "NY",
  "681": "WV",
  "682": "TX",
  "684": "AS",
  "701": "ND",
  "702": "NV",
  "703": "VA",
  "704": "NC",
  "706": "GA",
  "707": "CA",
  "708": "IL",
  "712": "IA",
  "713": "TX",
  "714": "CA",
  "715": "WI",
  "716": "NY",
  "717": "PA",
  "718": "NY",
  "719": "CO",
  "720": "CO",
  "724": "PA",
  "725": "NV",
  "726": "TX",
  "727": "FL",
  "731": "TN",
  "732": "NJ",
  "734": "MI",
  "737": "TX",
  "740": "OH",
  "743": "NC",
  "747": "CA",
  "754": "FL",
  "757": "VA",
  "760": "CA",
  "762": "GA",
  "763": "MN",
  "765": "IN",
  "769": "MS",
  "770": "GA",
  "772": "FL",
  "773": "IL",
  "774": "MA",
  "775": "NV",
  "779": "IL",
  "781": "MA",
  "785": "KS",
  "786": "FL",
  "801": "UT",
  "802": "VT",
  "803": "SC",
  "804": "VA",
  "805": "CA",
  "806": "TX",
  "808": "HI",
  "810": "MI",
  "812": "IN",
  "813": "FL",
  "814": "PA",
  "815": "IL",
  "816": "MO",
  "817": "TX",
  "818": "CA",
  "820": "CA",
  "828": "NC",
  "830": "TX",
  "831": "CA",
  "832": "TX",
  "843": "SC",
  "845": "NY",
  "847": "IL",
  "848": "NJ",
  "850": "FL",
  "854": "SC",
  "856": "NJ",
  "857": "MA",
  "858": "CA",
  "859": "KY",
  "860": "CT",
  "862": "NJ",
  "863": "FL",
  "864": "SC",
  "865": "TN",
  "870": "AR",
  "872": "IL",
  "878": "PA",
  "901": "TN",
  "903": "TX",
  "904": "FL",
  "906": "MI",
  "907": "AK",
  "908": "NJ",
  "909": "CA",
  "910": "NC",
  "912": "GA",
  "913": "KS",
  "914": "NY",
  "915": "TX",
  "916": "CA",
  "917": "NY",
  "918": "OK",
  "919": "NC",
  "920": "WI",
  "925": "CA",
  "928": "AZ",
  "929": "NY",
  "930": "IN",
  "931": "TN",
  "934": "NY",
  "936": "TX",
  "937": "OH",
  "938": "AL",
  "940": "TX",
  "941": "FL",
  "947": "MI",
  "949": "CA",
  "951": "CA",
  "952": "MN",
  "954": "FL",
  "956": "TX",
  "959": "CT",
  "970": "CO",
  "971": "OR",
  "972": "TX",
  "973": "NJ",
  "975": "MO",
  "978": "MA",
  "979": "TX",
  "980": "NC",
  "984": "NC",
  "985": "LA",
  "989": "MI",
}

/**
 * Get the US state abbreviation from a phone number's area code
 * @param phoneNumber The phone number to extract the state from
 * @returns The two-letter US state abbreviation or undefined if not found
 */
export function getUSStateFromPhoneNumber(phoneNumber: string): string | undefined {
  try {
    const parsedNumber = parsePhoneNumberWithError(phoneNumber, {
      defaultCountry: "US",
    })
    if (parsedNumber.country !== "US") return undefined

    // Get the area code from the national format
    const areaCode = parsedNumber.formatNational().split(")")[0].replace("(", "").trim()
    return areaCodeToState[areaCode]
  } catch (err) {
    console.error("Error getting US state from phone number", err)
    return undefined
  }
}

/**
 * Takes in a phone number and an optional contact name and returns a formatted string
 * with the contact name and the phone number in either national or international format.
 *
 * If the phone number is invalid, the function will return an empty string unless showInvalidValues is true.
 * @param {string | undefined} phone - the phone number to format
 * @param {string | undefined} contactName - the name of the contact associated with the phone number
 * @param {boolean | undefined} showInvalidValues - whether to show invalid phone numbers
 * @returns {string} - the formatted string with the contact name and phone number
 * @throws {Error} - if no phone number is provided
 */
export function prettifyPhone({ contactName, phone, showInvalidValues }: { phone?: string; contactName?: string; showInvalidValues?: boolean }): string {
  let ret = ""
  try {
    if (!phone) return ""

    const phoneNumber = parsePhoneNumberWithError(phone, {
      extract: true,
      defaultCountry: "US",
    })

    if (!phoneNumber?.isValid()) {
      if (showInvalidValues) {
        return contactName ? `${contactName} (${phone})` : phone
      } else {
        return ""
      }
    }

    const isUSPhone = phoneNumber.getPossibleCountries().includes("US")

    if (isUSPhone) {
      ret = contactName ? `${contactName} (${phoneNumber.formatNational()})` : phoneNumber.formatNational()
    } else {
      ret = contactName ? `${contactName} (${phoneNumber.formatInternational()})` : phoneNumber.formatInternational()
    }
  } catch (err) {
    console.warn(err)
    ret = contactName ?? "Unknown"
  }
  return ret
}
